export default __webpack_public_path__ + "static/media/giftSetDeliveryIcon.712d790e.jpg";